export enum LogExportInsStorageType {
    AzureEventHub = 'AzureEventHub',
    AwsSqs = 'AWSSQS',
    Splunk = 'SplunkHec',
    None = 'None',
}
